import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ContentfulService } from './contentful.service';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProductListComponent } from './product-list/product-list.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { CompanyInfoComponent } from './company-info/company-info.component'


@NgModule({
  declarations: [
    AppComponent,
    ProductListComponent,
    ContactListComponent,
    CompanyInfoComponent
  ],
  imports: [
    BrowserAnimationsModule,
    MatGridListModule,
    MatCardModule,
    BrowserModule,
    CommonModule
  ],
  providers: [
    ContentfulService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
